import React, {memo} from 'react';
import '../../Styles/Search.css'

const Search = ({placeholder, handleChange}) => {

    return (
        <input type='search'
               className='handwai-search'
               placeholder={placeholder} // dynamic for reusability
               onChange={handleChange}
        />
    )
}

export default memo(Search);